<template>
  <div class="post relative overflow-scroll" id="post" @wheel.stop>
    <blogWrappers :post="true" />
    <div class="pt-50 pl-82.5 pr-50 w-full flex flex-col gap-25 slide min-h-screen">
      <div class="header pr-32.5 flex">
        <div class="tags w-66 flex flex-wrap pr-10 flex-shrink-0 gap-4">
          <p
              v-for="tag in text.tags" :key="tag"
            class="posts-topic cursor-pointer font-semibold fz-13 uppercase w-max h-max py-1.25 px-4 rounded-full border"
          >
            {{ tags[tag] }}
          </p>
        </div>

        <div class="flex flex-col">
          <div class="flex">
            <div class="title">
              <h2 class="font-light fz-45" style="color: #ff2e53">
                {{ text.title }}
              </h2>
            </div>
            <div class="share w-66 flex-shrink-0 flex justify-end">
              <img src="@/assets/images/share.svg" class="w-12 h-12" alt="" />
            </div>
          </div>
          <div class="header-text pr-32.5 mt-12 mr-66">
            <p class="fz-201 text-white mb-12 font-medium">
              {{ text.headerText }}
            </p>
            <p
              class="date font-medium fz-10"
              style="letter-spacing: 0.3rem; color: #6e758d"
            >
              {{ text.date }}
            </p>
          </div>
        </div>
      </div>

      <div v-for="contentPart in Object.entries(text.content)" :key="contentPart[0]">
        <imageElement v-if="contentPart[0].includes('imageElement')" :source="postId + '/' + contentPart[1].source"/>
        <doubleSlider v-else-if="contentPart[0].includes('doubleSlider')" :images="contentPart[1].sources" :id="postId" src="blog" />
        <postSection v-else-if="contentPart[0].includes('postSection')" :content="contentPart[1]"/>
        <imageWithMark v-else-if="contentPart[0].includes('imageWithMark')" :source="postId + '/' + contentPart[1].source" :mark="contentPart[1].marks"/>
      </div>
    </div>
    <div class="pl-82.5 pr-50">
      <a
          href="#post"
          class="w-max to-top ml-66 mt-40 transform transition cursor-pointer"
      >
        <svg
            width="14"
            class="transform transition duration-800 rotate-180"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 6L7 12L13 6" stroke-linejoin="round" />
          <path d="M6.99998 0V12" stroke-linejoin="round" />
        </svg>
        <p
            class="fz-10 font-medium uppercase mt-2.5"
            style="letter-spacing: 0.3em"
        >
          {{ all.back }}
        </p>
      </a>

<!--      <div-->
<!--          class="next cursor-pointer w-315 relative"-->
<!--          v-if="text.nextTitle"-->
<!--          @click="$emit('nextPost')"-->
<!--      >-->
<!--        &lt;!&ndash; Background start &ndash;&gt;-->
<!--        <div class="absolute w-full h-full shadow z-10"></div>-->
<!--        <img-->
<!--            class="w-full"-->
<!--            :src="require('@/assets/images/blog/' + postId + '/next.png')"-->
<!--            alt=""-->
<!--        />-->
<!--        <div class="line absolute bottom-0 h-2"></div>-->
<!--        &lt;!&ndash; Background end &ndash;&gt;-->
<!--        <div class="content absolute z-20 bottom-23 left-10">-->
<!--          <p class="next-post-title fz-13 uppercase font-semibold mb-6">-->
<!--            {{ all.next }}-->
<!--          </p>-->
<!--          <h3 class="w-110 fz-301">{{ text.nextTitle }}</h3>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>
</template>

<script>
import doubleSlider from "../doubleSlider";
import blogWrappers from "./blogWrappers";
import imageElement from "@/components/desktop/blog/postElements/imageElement";
import imageWithMark from "@/components/desktop/blog/postElements/imageWithMark";
import markedList from "@/components/desktop/blog/postElements/markedList";
import miniMarkedList from "@/components/desktop/blog/postElements/miniMarkedList";
import numberedList from "@/components/desktop/blog/postElements/numberedList";
import sectionHeader from "@/components/desktop/blog/postElements/sectionHeader";
import textElement from "@/components/desktop/blog/postElements/textElement";
import postSection from "@/components/desktop/blog/postElements/postSection";
import {mapState} from "vuex";

export default {
  name: "post",
  emits: ["nextPost"],
  components: {
    doubleSlider,
    blogWrappers,
    imageElement,
    imageWithMark,
    markedList,
    miniMarkedList,
    numberedList,
    sectionHeader,
    textElement,
    postSection
  },
  computed: {
    ...mapState(['lang', 'postId']),
    all() {
      return require("@/assets/text/blog/posts/" + this.lang + ".json");
    },
    text() {
      return this.all.posts[this.postId];
    },
    tags(){
      return this.all.tags;
    },
  },
  mounted() {
    document.querySelector('.post').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
};
</script>

<style lang="scss" scoped>
// Next post start
.next {
  margin-top: 9rem;
  overflow: hidden;
  height: 18.75rem;
  transition: all linear 0.3s;
  .line {
    transition: all linear 0.3s;
    background: #ff2e53;
    width: 0;
    z-index: 11;
  }
  img.w-full {
    transition: all linear 0.3s;
  }
  .shadow {
    transition: all linear 0.3s;
    background: rgba(0, 0, 0, 0.8);
  }
}
.next:hover {
  //margin-top: 7.125rem;
  //height: 20.625rem;
  .line {
    width: 100%;
  }
  img.w-full {
    transform: scale(1.15);
  }
  .shadow {
    background: rgba(0, 0, 0, 0.4);
  }
}
// Next post end

//Back to top button start
.to-top {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: rgba(151, 163, 203, 0.6);
    }
  }
  p {
    transition: all linear 0.3s;
    color: rgba(151, 163, 203, 0.6);
  }
}
.to-top:hover {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: white;
    }
  }
  p {
    transition: all linear 0.3s;
    color: white;
  }
}
//Back to top button end
</style>
